import {Component, EventEmitter, HostListener, Input, Output, signal} from '@angular/core';


import { Chantier } from '../../../../shared/models/chantier'

@Component({
  selector: 'lg-chantier-selector',
  imports: [],
  templateUrl: './chantier-selector.component.html',
  styleUrl: './chantier-selector.component.scss'
})
export class ChantierSelectorComponent {
  @Input({required: true})
  selectableChantiers: Chantier[]
  @Input()
  selectedChantier: Chantier
  @Output()
  chantierSelected = new EventEmitter<string>()

  showOptions = signal<boolean>(false)

  @HostListener('body:click')
  onClickOutsideChantierDisplay(): void {
    this.showOptions.set(false)
  }
  onChantierSelected(selectedChantierCode: string): void {
    console.log(selectedChantierCode)
    this.chantierSelected.emit(selectedChantierCode)
  }

  onChantierDisplayClicked(event: MouseEvent):void {
    event.stopPropagation()
    this.showOptions.set(!this.showOptions())
  }
}
